import {
  SimpleForm,
  NumberInput,
  Toolbar,
  SaveButton,
  Button,
  required,
  maxValue,
} from "react-admin";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useNotify } from "react-admin";
import { integerOnly } from "../validators";
const COUNT_BINS_MAX = 5000;

export const ProviderInventoryCreate = () => {
  const { search } = useLocation();
  const navigate = useNavigate();
  const notify = useNotify();
  const providerId = new URLSearchParams(search).get("providerId")!;

  const onSubmit = async (values: any) => {
    const token = localStorage.getItem("kc_token");
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/provider-inventory/${providerId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            ...(token && { Authorization: `Bearer ${token}` }),
          },
          body: JSON.stringify(values),
        }
      );
      if (!res.ok) {
        const text = await res.text();
        throw new Error(text || res.statusText);
      }
      notify("Inventaire créé", { type: "success" });
      navigate(`/provider-inventory/details/${providerId}`);
    } catch (err: any) {
      notify(err.message || "Erreur lors de la création", { type: "error" });
    }
  };

  return (
    <>
      <h2>Ajouter un inventaire prestataire</h2>
      <SimpleForm
        onSubmit={onSubmit}
        toolbar={
          <Toolbar>
            <SaveButton />
            <Button
              component={Link}
              variant="outlined"
              color="secondary"
              size="large"
              to={`/provider-inventory/details/${providerId}`}
              sx={{ ml: 2, pl: 4 }}
            >
              Annuler
            </Button>
          </Toolbar>
        }
      >
        <NumberInput
          source="fullBinsCount"
          label="Caisses pleines"
          validate={[
            required("La quantité de caisse est requise"),
            maxValue(COUNT_BINS_MAX, `Maximum ${COUNT_BINS_MAX}`),
            integerOnly("Doit être un nombre décimal"),
          ]}
        />
        <NumberInput
          source="emptyBinsCount"
          label="Caisses vides"
          validate={[
            required("La quantité de caisse est requise"),
            maxValue(COUNT_BINS_MAX, `Maximum ${COUNT_BINS_MAX}`),
            integerOnly("Doit être un nombre décimal"),
          ]}
        />
      </SimpleForm>
    </>
  );
};
